import React from 'react';
import '../styles/auth-design.css';

const STEPS = ['Account', 'Hunter', 'Field Kit'];

export function AuthStepper({ step }) {
  return (
    <div
      className="auth-stepper"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={STEPS.length}
      aria-valuenow={step + 1}
      aria-label={`Sign up step ${step + 1} of ${STEPS.length}: ${STEPS[step]}`}
    >
      {STEPS.map((label, i) => {
        const active = i <= step;
        return (
          <div key={label} className="auth-stepper__segment">
            <div className={`auth-stepper__rail ${active ? 'is-active' : ''}`} />
            <div className={`auth-stepper__label ${active ? 'is-active' : ''}`}>
              {String(i + 1).padStart(2, '0')} {label}
            </div>
          </div>
        );
      })}
    </div>
  );
}
